import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.wholeHouse.usage.sortFields,
	columnFields: constants.wholeHouse.usage.columnFields,
	standardFilterFields: constants.wholeHouse.usage.osStandardFilterFields,
	dateFilterFields: constants.wholeHouse.usage.osDateFilterFields,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
